const collapse = () => {
    const elements = document.getElementsByClassName('collapse');
    let to: ReturnType<typeof setTimeout> | number = 0;

    const setAnimationVar = (el: Element) => {
        const wrp = el.querySelector('.wrp')!;
        const cnt = wrp.querySelector('.cnt')!;
        const h = cnt.scrollHeight;
        const styles = [`--collapse-height: ${h}px`, `--collapse-transition: ${Math.round(h * 2.4)}ms`];

        wrp.setAttribute('style', styles.join(';'));
    };

    const setAnimationVars = () => {
        for (let i = 0; i < elements.length; i++) {
            setAnimationVar(elements[i]);
        }
    };

    window.addEventListener('resize', () => {
        clearTimeout(to);
        to = setTimeout(setAnimationVars, 200);
    });

    setAnimationVars();
};

export default collapse;